module.exports = __webpack_public_path__ + "img/loginPageBanner.e65582a2.png";